
import BScroll from "better-scroll";
import MyCard from "@/components/Card";
import MyInput from "@/components/SearchInput";
import LoadMore from 'vux/src/components/load-more/index.vue'


export default {
data() {
return {
currentPage: 1,
pageSize: 10,
isLoading: false,
loadTip: "",
keyWord: this.$route.query.keyWord,
bscroll: "",
bookdata: []
};
},
components: {
MyCard,
LoadMore,
MyInput
},
watch: {
$route() {
this.keyWord = this.$route.query.keyWord;
this.getSearchResult(true);
}
},
methods: {
initScroll() {
let wrapper = document.querySelector(".result");
if (!this.bscroll) {
this.bscroll = new BScroll(wrapper, {
pullUpLoad: {
threshold: 50
},
click: true,
bounce: {
top: false,
bottom: false,
left: false,
right: false
}
});
} else {
this.bscroll.refresh();
}
this.bscroll.on("pullingUp", () => {
this.getSearchResult();
});
},
handleSearch(inputKeyWord) {
if (inputKeyWord.length === 0) {
this.$vux.toast.text("请输入搜索关键字");
} else {
if (this.$route.query.keyWord === inputKeyWord) {
this.getSearchResult(true);
} else {
this.$router.push({
name: "SearchResult",
query: {
keyWord: inputKeyWord
}
});
}
}
},
getSearchResult(resetPage) {
if (resetPage) {
this.currentPage = 1;
this.bookdata = [];
}
this.isLoading = true;
this.loadTip = "加载中";
this.$http("post", "/book/search", {
current: this.currentPage,
size: this.pageSize,
keyWord: this.keyWord
})
.then(res => {
this.isLoading = false;
res.data.forEach(book => {
let bookData = {
isbn: book["isbn"],
marcid: book["marcid"],
bookName: book["ztming"],
infos: [
{
name: "著者",
value:
book["zrsming"].length > 0
? book["zrsming"].split("，")[0] + "..."
: ""
},
{
name: "ISBN",
value: book["isbn"]
},
{
name: "出版社",
value: book["cbzhe"]
},
{
name: "主题",
value: book["zti"]
},
{
name: "页数",
value: book["yma"]
}
]
};
this.bookdata.push(bookData);
});
this.$nextTick(() => {
this.currentPage += 1;
if (res.data.length === 0) {
this.bscroll.closePullUp();
this.loadTip = "暂无数据";
} else {
this.bscroll.finishPullUp();
this.loadTip = "";
}
this.bscroll.refresh();
});
})
.catch(() => {
this.isLoading = false;
this.loadTip = "";
})
},
jumpBookDetail(params, bookdata) {
try {
sessionStorage.setItem("bookInfo", JSON.stringify(bookdata));
} catch (error) {

}
this.$router.push({
path: "/bookDetail",
query: {
isbn: params.isbn,
marcid: params.marcid
}
});
}
},
mounted() {
this.initScroll();
this.keyWord = this.$route.query.keyWord ? this.$route.query.keyWord : "";
if (this.keyWord.length > 0) {
this.getSearchResult(true);
}

},
destroyed() {

}
};
